<app-static-page-layout pageTitle="About CiraNet">
  <div class="about-content">
    <!-- CiraNet Section -->
    <section class="brand-section ciranet-section">
      <div class="logo-container ciranet-logo">
        <app-icon
          name="ciranet-logo"
          size="100%"
          ariaLabel="CiraNet Logo"
        ></app-icon>
      </div>

      <article class="article-block">
        <h2>About CiraNet Resident Portal</h2>
        <p>
          The CiraNet Resident Portal is a secure online tool that helps
          homeowners and residents access community and account information and
          complete common tasks online. CiraNet is a domain and brand owned by
          RealManage LLC.
        </p>
      </article>

      <article class="article-block">
        <h2>What you can do in the portal</h2>
        <p>Depending on your community, the portal may allow you to:</p>
        <ul>
          <li>View account information and statements</li>
          <li>Make payments online</li>
          <li>Access community documents and announcements</li>
          <li>Submit requests and stay informed through updates</li>
        </ul>
      </article>

      <article class="article-block">
        <h2>Who operates this portal</h2>
        <p>
          RealManage LLC provides community association management services and
          supports homeowner and condominium associations through financial
          management, communications, administration, and resident support.
        </p>
      </article>

      <article class="article-block">
        <h2>CiraNet ownership</h2>
        <p>
          CiraNet is a domain and brand owned by
          <strong>RealManage LLC</strong>
          .
        </p>
      </article>
    </section>

    <!-- RealManage Section -->
    <section class="brand-section realmanage-section">
      <div class="logo-container realmanage-logo">
        <app-icon
          name="realmanage-logo"
          size="100%"
          ariaLabel="RealManage Logo"
        ></app-icon>
      </div>

      <article class="article-block">
        <h2>About RealManage LLC</h2>
        <p>
          RealManage LLC provides community association management services and
          supports homeowner and condominium associations through financial
          management, communications, administration, and resident support. The
          Resident Portal is one of the tools RealManage offers to help
          communities stay connected, improve service, and enable convenient
          self-service for residents.
        </p>
      </article>
    </section>

    <!-- Google API Services Section -->
    <section class="brand-section google-api-section">
      <article class="article-block">
        <h2>Google API Services</h2>
        <p>
          CiraNet's use and transfer to any other app of information received
          from Google APIs will adhere to the
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
            rel="noopener noreferrer"
            class="external-link"
          >
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements. We only access your Google
          name and email to authenticate your account.
        </p>
      </article>
    </section>
  </div>
</app-static-page-layout>
